<section class="instructor-home">
    <section class="action">
        <section><a routerLink="home">Home</a></section>
        <section><a routerLink="my-assignments">Assignments</a></section>
    </section>
    <section class="content">
        <router-outlet></router-outlet>
    </section>
</section>
